module.exports = __webpack_public_path__ + "img/cross.8f65366e.svg";